import { render, staticRenderFns } from "./ContactModal.vue?vue&type=template&id=2285f1d7"
import script from "./ContactModal.vue?vue&type=script&lang=js"
export * from "./ContactModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2285f1d7')) {
      api.createRecord('2285f1d7', component.options)
    } else {
      api.reload('2285f1d7', component.options)
    }
    module.hot.accept("./ContactModal.vue?vue&type=template&id=2285f1d7", function () {
      api.rerender('2285f1d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/companysetting/assets/ContactModal.vue"
export default component.exports